import React from 'react';
import { Route, Routes } from 'react-router-dom';
import IndexPage from '../stores/IndexPage';
import DemoStores from '../stores/DemoStores';
import ProductsPage from '../commons/ProductsPage';
import ApiPage from '../sdk/ApiPage';

/*
 * This component changes the content area with the appropriate pages without refresh
 */
const getContent = () => (
  <div>
    <Routes>
      <Route path="/" element={<IndexPage />} />
      <Route path="/stores" element={<DemoStores />} />
      <Route
        path="/stores/sdk/products"
        element={<ProductsPage storeType="sdk" />}
      />
      <Route path="/stores/sdk/api" element={<ApiPage />} />
      <Route
        path="/stores/lto/products"
        element={<ProductsPage storeType="lto" />}
      />
    </Routes>
  </div>
);

export default getContent;
